import {Component} from "@angular/core";
import {WorkflowStep} from "./workflow-step";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "./workflow.service";

@Component({
  templateUrl: "./sample-step.template.pug",
})
export class SampleStepComponent extends WorkflowStep {
  showDemoControls: boolean = false;

  otherViewButton: boolean = false;
  saveButton: boolean = false;

  showTable: boolean = false;
  showForm1: boolean = false;
  showForm2: boolean = false;
  showCards: boolean = false;

  searchBox: boolean = false;

  tableHasItems: boolean = false;
  extraActionButton: boolean = false;
  extraActionButtonIsDropdown: boolean = false;

  searchText: string = "";
  pageSize: number = 10;
  currentPage: number = 1;
  totalCount: number = 35;
  maxPages: number = 4;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }

  ready(): any {
    return undefined;
  }

  onListControlsChange() {}
}
